import { ListOfStatements } from './list-of-statements';
import { Root } from './root';

export const StatementsPage = {
  Root,
  ListOfStatements,
};
